import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './ZonasComponent.module.css'
import { insertSublocalidad, updateSublocalidad } from '../../../redux/DucksUnidadInspeccion/SublocalidadDuck'

import { useDispatch } from 'react-redux';
import MapaPickerComponent from './MapaPickerComponent';

const SublocalidadFormComponent = (props) => {

    const zona = props.zona
    const localidad = props.localidad

    const dispatch = useDispatch()
    const sublocalidadModify = props.sublocalidadModify
    const [defaultLocation, setDefaultLocation] = useState({ lat: Number(localidad.latitud), lng: Number(localidad.longitud) });
    const [location, setLocation] = useState(defaultLocation);

    const [inicialStateFormik, setInicialStateFormik] = useState({
        idsublocalidad: '', idlocalidad: localidad.idlocalidad, nombresublocalidad: '', lat: Number(localidad.latitud), lng: Number(localidad.longitud), pin: ''
    }
    )

    React.useState(() => {

        if (sublocalidadModify !== null) {
            console.log(sublocalidadModify)
            if (sublocalidadModify.latitud != "") {
                setInicialStateFormik({
                    idsublocalidad: sublocalidadModify.idsublocalidad,
                    idlocalidad: sublocalidadModify.idlocalidad,
                    nombresublocalidad: sublocalidadModify.nombresublocalidad,
                    lat: Number(sublocalidadModify.latitud) + '',
                    lng: Number(sublocalidadModify.longitud) + '',
                    pin: sublocalidadModify.pin,
                })

                //SE CARGA LA 
                setLocation({ lat: Number(sublocalidadModify.latitud), lng: Number(sublocalidadModify.longitud) })

            } else {
                console.log("aqui")
                setInicialStateFormik({
                    idsublocalidad: sublocalidadModify.idsublocalidad,
                    idlocalidad: sublocalidadModify.idlocalidad,
                    nombresublocalidad: sublocalidadModify.nombresublocalidad,
                    lat: Number(localidad.latitud) + '',
                    lng: Number(localidad.longitud) + '',
                    pin: sublocalidadModify.pin,
                })

                //SE CARGA LA 
                setLocation({ lat: Number(localidad.latitud), lng: Number(localidad.longitud) })
            }


            //SE CARGA LA 
            //setLocation({ lat: Number(sublocalidadModify.latitud), lng: Number(sublocalidadModify.longitud) })
        }
        else {
            console.log(localidad.latitud)
            setLocation({ lat: Number(localidad.latitud), lng: Number(localidad.longitud) })
        }

    }, [sublocalidadModify])

    return (
        <Fragment>
            <div className='row'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ${estilos.contenedorBorder}`}>
                    <div className='row'>
                        <h1 className={`${estilos.tituloForm}`}>{
                            sublocalidadModify ?
                                "Editar Sublocalidad " + sublocalidadModify.nombresublocalidad + " de la localidad" :
                                `Añadir sublocalidad a la localidad ' ${localidad.nombrelocalidad}'`
                        }</h1>
                    </div>

                    <MapaPickerComponent ubicacion={location} setLocation={setLocation} />

                    <Formik
                        initialValues={inicialStateFormik}
                        validate={values => {
                            const errors = {};
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            if (sublocalidadModify) {
                                const data = {
                                    data: {
                                        idsublocalidad: values.idsublocalidad,
                                        idlocalidad: localidad.idlocalidad,
                                        nombresublocalidad: values.nombresublocalidad,
                                        latitud: Number(location.lat) + '',
                                        longitud: Number(location.lng) + '',
                                        //pin: 'red'
                                    }
                                }
                                dispatch(updateSublocalidad(data))
                                props.actualizarSublocalidades()
                                //props.handleClose()
                            } else {
                                const data = {
                                    data: {
                                        idlocalidad: localidad.idlocalidad,
                                        nombresublocalidad: values.nombresublocalidad,
                                        latitud: Number(location.lat) + '',
                                        longitud: Number(location.lng) + '',
                                        //pin: 'red'
                                    }
                                }
                                dispatch(insertSublocalidad(data))
                                props.actualizarSublocalidades()
                                //props.handleClose()
                            }
                            setSubmitting(false);
                            props.onClose()
                        }}
                    >

                        {({ isSubmitting }) => (
                            <Form>
                                <div className={`container ${estilos.contenedorForm}`}>

                                    <Field type="hidden" name="idlocalidad" className='form-control' value={localidad.idlocalidad} />

                                    <label htmlFor="nombresublocalidad">Nombre de la Sublocalidad:</label><br />
                                    <Field type="text" name="nombresublocalidad" className='form-control' />
                                    <ErrorMessage name="nombresublocalidad" component="div" className={`${estilos.error}`} />


                                    <Field type="hidden" name="lat" className='form-control' />
                                    <ErrorMessage name="lat" component="div" className={`${estilos.error}`} />

                                    <Field type="hidden" name="lng" className='form-control' />
                                    <ErrorMessage name="lng" component="div" className={`${estilos.error}`} /><br />

                                    <div className='text-center'>
                                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                            {
                                                sublocalidadModify ?
                                                    "Guardar cambios" :
                                                    "Agregar Localidad"
                                            }
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}

                    </Formik>

                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(SublocalidadFormComponent)